export const getBulkAarHeaderStyle = (_, { palette = {} }) => ({
  title: {
    fontSize: 20,
    fontStyle: 'normal',
    fontFamily: 'Segoe UI',
    fontWeight: 600,
    lineHeight: '27px',
    marginTop: 24,
    marginLeft: 27,
    marginBottom: 14,
  },
  bulkAarDescription: {
    paddingLeft: 27,
    marginTop: 20,
    marginBottom: 20,
    whiteSpace: 'pre-line',
  },
  bulkAarInstruction: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 20,
  },
  bulkAarInstructionStep: {
    width: 500,
    padding: '10px 27px',
    lineHeight: '24px',
    borderRight: 'solid 0.5px #979797',
    '& ol': {
      marginTop: 9,
      paddingLeft: 20,
    },
  },
  '@media (max-width: 1100px)': {
    bulkAarInstruction: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 20,
    },
    bulkAarInstructionStep: {
      borderRight: 'none',
    },
  },
  sampleTable: {
    width: 600,
    margin: '10px 27px',
    '& table': {
      marginLeft: 20,
      borderLeft: '2px solid #fff',
      borderRight: '2px solid #fff',
    },
    '& thead': {
      borderTop: '2px solid #979797',
      borderBottom: '2px solid #979797',
      fontWeight: 600,
    },
    '& td': {
      padding: '4px 8px',
      border: '1px solid #EDEBE9',
    },
  },
  bulkAarStep: {
    width: 500,
    padding: '10px 27px',
    paddingRight: 5,
    lineHeight: '24px',
    '& ol': {
      marginTop: 9,
      paddingLeft: 20,
    },
  },
  uploadContatiner: {
    marginLeft: 27,
    marginBottom: 16,
    '& #select-file-format': {
      marginRight: 6,
      fontColot: '#B3B0AD',
      height: 32,
      width: 220,
    },
  },
  uploadInput: {
    display: 'none !important',
  },
  fileUploadDescription: {
    fontSize: 12,
    opacity: 0.6,
    marginTop: 4,
  },
  fileRemove: {
    border: 'unset',
    background: 'unset',
    padding: 'unset',
    marginLeft: 12,
    fontSize: 14,
    color: palette.accent,
  },
  fileInfo: {
    display: 'inline',
    fontSize: 14,
    marginLeft: 5,
  },
  fileError: {
    marginTop: 6,
    fontSize: 14,
    color: '#A80000',
  },
  fileFormat: {
    marginTop: 6,
    fontSize: 14,
    color: '#A19F9D',
  },
  fileInfoContainer: {
    display: 'inline-flex',
    height: 32,
    alignItems: 'center',
  },
});
